import { Check } from "lucide-react";
import { featureDomains as domains } from "./featuresData";

type FeaturesDetailedProps = {
  heading?: string;
  subheading?: string;
};

const FeaturesDetailed = ({
  heading = "Tout ce qui est inclus",
  subheading = "Toutes les fonctionnalités, sans limite, dans chaque offre.",
}: FeaturesDetailedProps) => {
  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-14">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-foreground mb-4">
            {heading}
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {subheading}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-10 max-w-6xl mx-auto">
          {domains.map((domain) => {
            const Icon = domain.icon;
            return (
              <div key={domain.title} className="space-y-4">
                <div className="flex items-center gap-3 pb-3 border-b border-border">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon className="w-5 h-5 text-primary" />
                  </div>
                  <h3 className="font-playfair text-xl font-semibold text-foreground">
                    {domain.title}
                  </h3>
                </div>
                <ul className="space-y-2">
                  {domain.features.map((feature) => (
                    <li key={feature} className="flex items-start gap-2 text-sm text-muted-foreground">
                      <Check className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesDetailed;
